<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .table-components {
    flex-direction: column;
    justify-content: space-between;
    gap: utils.in_rem(8px);
    display: flex;
    flex-direction: column;
    overflow: auto;
    height: 100%;
    flex: 1;
    min-height: 0;

    .background {
      background-color: colors.get(textWhite);
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      flex: 1;
    }
  }

  a[href] {
    color: colors.get(primary_50);
    white-space: nowrap;
  }

  span {
    white-space: nowrap;
  }
</style>

<script>
  import DataTable from "@sourcewhale/shared/svelte-design-system/components/molecules/DataTable/DataTable.svelte";
  import PaginationGroup from "@sourcewhale/shared/svelte-design-system/components/molecules/Pagination/PaginationGroup.svelte";
  import NoData from "./NoData.svelte";
  import Contact from "./TableComponents/Contact.svelte";
  import Direction from "./TableComponents/Direction.svelte";
  import Duration from "./TableComponents/Duration.svelte";
  import Outcome from "./TableComponents/Outcome.svelte";
  import Recording from "./TableComponents/Recording.svelte";
  import Timestamp from "./TableComponents/Timestamp.svelte";
  import User from "./TableComponents/User.svelte";

  let {
    callsQuery,
    callsQueryParams,
    callsQueryStore,
    style,
    paginationGroupStyle,
  } = $props();

  let paginationClientHeight = $state(0);
  const backgroundStyle = $derived(
    `height: calc(100% - ${paginationClientHeight}px - 24px); ${style}`
  );

  // Include columns directly from callsQueryParams, similar to ToDosTable
  let columns = $derived.by(() =>
    callsQueryParams.columns.map((c) => ({
      ...c,
      sticky: c.name === "recorded" ? "left" : null,
    }))
  );

  const { meta } = callsQueryStore;
  let skeleton = $derived.by(() => !$meta.firstFetchDone);
</script>

{#snippet link(href, text)}
  {#if skeleton}
    <span class:skeleton>Loading...</span>
  {:else}
    <a {href} target="blank_" rel="noreferrer noopener">{text}</a>
  {/if}
{/snippet}

<div class="table-components">
  <div class="background" style={backgroundStyle}>
    <DataTable
      class="flex-1"
      {columns}
      data={callsQuery.data}
      bind:order={callsQueryParams.order}
      {skeleton}
      fetching={$meta.fetching}
      loadingMessage="Loading Calls..."
    >
      {#snippet recorded(call)}
        <Recording {call} {skeleton} />
      {/snippet}

      {#snippet user(u)}
        <User user={u} {skeleton} />
      {/snippet}

      {#snippet kind(k)}
        <Direction kind={k} {skeleton} />
      {/snippet}

      {#snippet candidate(c, call)}
        <Contact candidate={c} {call} {skeleton} />
      {/snippet}

      {#snippet duration(value)}
        <Duration duration={value} {skeleton} />
      {/snippet}

      {#snippet timestamp(value)}
        <Timestamp {value} {skeleton} />
      {/snippet}

      {#snippet campaign(call)}
        {#if call?.campaignId}
          {@const href = `/campaign?campaignId=${call.campaignId}`}
          {@render link(href, call?.campaign || "Unknown Name")}
        {/if}
      {/snippet}

      {#snippet outcome(call)}
        <Outcome {call} {skeleton} />
      {/snippet}

      {#snippet noData()}
        <NoData icon="fa-regular fa-phone" text="No matching calls" />
      {/snippet}
    </DataTable>
  </div>
  <PaginationGroup
    style={paginationGroupStyle}
    bind:clientHeight={paginationClientHeight}
    bind:start={callsQueryParams.start}
    bind:length={callsQueryParams.length}
    total={callsQuery.recordsTotal}
  />
</div>
